import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, MessageSquareText, Settings, Orbit } from 'lucide-react';
import { Card, Button } from 'src/common';

interface AppGridProps {
  onClose: () => void;
  onBackToPlayground: () => void;
}

export function AppGrid({ onClose, onBackToPlayground }: AppGridProps) {
  const navigate = useNavigate();

  const apps = [
    {
      id: 'rogers-vqa',
      name: 'Rogers VQA',
      description: 'Visual Question Answering',
      icon: MessageSquareText,
      color: 'bg-blue-500',
      path: '/rogers-vqa',
    },
    {
      id: 'bez-plus',
      name: 'Bez Plus',
      description: '3D Satellite Scene Viewer',
      icon: Orbit,
      color: 'bg-purple-500',
      path: '/bez-plus',
    },
    {
      id: 'settings',
      name: 'Settings',
      description: 'App & General Settings',
      icon: Settings,
      color: 'bg-gray-500',
      path: '/settings',
    }
  ];

  const handleAppClick = (appId: string) => {
    const app = apps.find(a => a.id === appId);
    if (!app?.path) return;
    navigate(app.path);
  };

  return (
    <div className="fixed inset-0 backdrop-blur-sm z-50 flex items-center justify-center background-overlay">
      <div className="w-full max-w-xs mx-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xs md:text-xl">AI Playground Apps</h2>
          <Button variant="ghost" size="sm" onClick={onClose}>
            <X className="w-5 h-5 text-muted-foreground" />
          </Button>
        </div>

        {/* App Grid */}
        <div className="grid grid-cols-2 gap-6">
          {apps.map((app) => (
            <Card
              key={app.id}
              className="bg-card border-border p-3 md:p-6 transition-colors cursor-pointer hover:bg-muted"
              onClick={() => handleAppClick(app.id)}
            >
              <div className="flex flex-col items-center text-center space-y-2 md:space-y-3">
                <div className={`w-10 h-10 md:w-12 md:h-12 ${app.color} rounded-xl flex items-center justify-center`}>
                  <app.icon className="w-4 h-4 md:w-6 md:h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-size-14">{app.name}</h3>
                  <p className="text-muted-foreground font-size-12">{app.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-xs text-blue-400 light:text-blue-600 cursor-pointer hover:text-blue-300 light:hover:text-blue-700">More Apps ...</p>
        </div>
      </div>
    </div>
  );
}